import { useEffect, useState } from 'react';
import axios from 'axios';

const UseThumbnailUrl = (thumbnail_info, size) => {
  const [thumbnailUrl, setThumbnailUrl] = useState('');
  const [locationData, setLocationData] = useState({ location: 'seoul' });

  useEffect(() => {
    const fetchData = async () => {
      // 로컬 환경에서 제외(local 환경에서 cors error)
      if (process.env.NODE_ENV !== 'development') {
        try {
          const storedData = localStorage.getItem('locationData');
          let data;

          if (storedData === null) {
            const response = await axios.get('https://location.mubeat.tv/');
            data = response.data;
            localStorage.setItem('locationData', JSON.stringify(data));
          } else {
            data = JSON.parse(storedData);
          }

          setLocationData(data);
        } catch (error) {
          console.error('error', error);
        }
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    let fullUrl = '';
    const location = locationData?.location;
    const region = location === 'saopaulo' || location === 'virginia' || location === 'london' ? `${location}.` : '';

    if (thumbnail_info) {
      fullUrl = `${thumbnail_info.scheme}${region}${thumbnail_info.host}${thumbnail_info.imgpath}?size=${size}`;

      // 로컬 환경에서 region 없이 사용(별도의 size query string 작동 X)
      if (process.env.NODE_ENV === 'development') {
        fullUrl = `${thumbnail_info.scheme}${thumbnail_info.host}${thumbnail_info.imgpath}?size=${size}`;
      }
    }

    setThumbnailUrl(fullUrl);
  }, [thumbnail_info, locationData, size]);

  return thumbnailUrl;
};

export default UseThumbnailUrl;
